<template>
  <v-container fluid class="down-top-padding">
    <v-row>
      <v-col cols="12" lg="12">
        <v-card>
          <v-toolbar flat>
            <v-col cols="12" class="px-0">
              <div class="d-flex align-center">
                <div class="text-left">
                  <v-toolbar-title class="page-title">
                    Request Top-up
                  </v-toolbar-title>
                </div>
                <!-- <div class="ml-auto">
                  <v-btn color="primary" @click="addIbasUser()">
                    <v-icon class="mr-2">mdi-plus</v-icon> Add
                  </v-btn>
                </div> -->
              </div>
            </v-col>
            <v-spacer></v-spacer>
          </v-toolbar>

          <v-divider></v-divider>

          <v-row>
            <v-col cols="12">
              <v-card>
                <v-form ref="form" lazy-validation>
                  <v-card-title class="text-h5">
                    <!-- {{ title }} -->
                  </v-card-title>

                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="8" class="mt-0 pt-0">
                          <v-select
                            :items="banks"
                            item-text="name"
                            item-value="name"
                            label="Banks*"
                            :rules="rules.required"
                            v-model="form.bankName"
                            return-object
                            v-on:change="getBank"
                          ></v-select>
                        </v-col>

                        <v-col cols="4" class="mt-0 pt-0">
                          <v-text-field
                            label="Bank Code*"
                            v-model="form.bankCode"
                            :rules="rules.required"
                            :disabled="true"
                          ></v-text-field>
                        </v-col>

                        <v-col cols="12" class="mt-0 pt-0">
                          <v-text-field
                            label="Account Name*"
                            v-model="form.bankAccountName"
                            :rules="rules.required"
                            :disabled="true"
                          ></v-text-field>
                        </v-col>

                        <v-col cols="12" class="mt-0 pt-0">
                          <v-text-field
                            label="Account Number*"
                            v-model="form.bankAccountNumber"
                            :rules="rules.required"
                            :disabled="true"
                          ></v-text-field>
                        </v-col>

                        <v-col cols="12" class="mt-0 pt-0">
                          <v-text-field
                            label="Account Type*"
                            v-model="form.bankType"
                            :rules="rules.required"
                            :disabled="true"
                          ></v-text-field>
                        </v-col>

                        <v-col cols="6" class="mt-0 pt-0">
                          <v-select
                            :items="loadTypes"
                            label="Wallet Type*"
                            :rules="rules.required"
                            v-model="form.loadType"
                          ></v-select>
                        </v-col>
                        <!-- @input.native="changeWallet" -->
                        <v-col cols="6" class="mt-0 pt-0">
                          <vuetify-money
                            v-model="form.amount"
                            label="Amount*"
                            :rules="rules.required"
                            :options="vmoney.options"
                            :clearable="true"
                          />
                        </v-col>
                        <!-- <v-col cols="6" class="mt-0 pt-0">
                          <v-text-field
                            label="Amount*"
                            v-model="form.amount"
                            :rules="rules.required"
                            :hint="`Expected S2S Points: ${s2sPoints}`"
                            persistent-hint
                            type="number"
                            @blur="changeWallet"
                          ></v-text-field>
                        </v-col> -->

                        <v-col cols="6" class="mt-0 pt-0">
                          <v-text-field
                            label="Reference Number*"
                            v-model="form.referenceNumber"
                            :rules="rules.required"
                          ></v-text-field>
                        </v-col>

                        <v-col cols="6" class="mt-0 pt-0">
                          <v-file-input
                            counter
                            show-size
                            label="Upload Proof of Payment*"
                            truncate-length="15"
                            prepend-icon=""
                            append-icon="mdi-image"
                            accept="image/*"
                            :rules="rules.required"
                            @change="handleImage"
                          ></v-file-input>
                        </v-col>
                      </v-row>
                    </v-container>
                    <small>*indicates required field</small>
                  </v-card-text>

                  <v-card-actions class="pb-5">
                    <v-spacer></v-spacer>
                    <v-btn @click.prevent="cancel"> Cancel </v-btn>
                    <v-btn
                      color="primary"
                      :loading="loadingBtn"
                      :disabled="loadingBtn"
                      @click="onSubmit()"
                      class="px-10"
                    >
                      Submit
                    </v-btn>
                  </v-card-actions>
                </v-form>
              </v-card>
            </v-col>
            <Snackbar />
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <ConfirmationDiaglog ref="confirm" />
    <Snackbar />
  </v-container>
</template>

<script>
import ShareableMethods from "@/mixins/ShareableMethods";
import Snackbar from "../dialogs/Snackbar.vue";
import ConfirmationDiaglog from "../dialogs/ConfirmationDiaglogv2.vue";

export default {
  mixins: [ShareableMethods],
  name: "ServiceProviderRequestTopUp",
  components: { Snackbar, ConfirmationDiaglog },
  data() {
    return {
      percent: "",
      vmoney: {
        options: {
          locale: "en-PH",
          prefix: "",
          suffix: "",
          length: 11,
          precision: 2,
        },
        properties: {
          ref: "amount",
          // You can add other v-text-field properties, here.
        },
      },

      s2sPoints: "0",
      banks: [],
      loadTypes: ["Load Wallet", "Install Wallet"],
      rules: {
        required: [(value) => !!value || "Required."],
      },
      form: {
        distributorDealerId: "",
        distributorMobileNumber: "",
        bankName: "",
        bankCode: "",
        bankAccountName: "",
        bankAccountNumber: "",
        bankType: "",
        amount: "",
        image: "",
        referenceNumber: "",
        loadType: "Load Wallet",
      },

      loadingBtn: false,
    };
  },

  methods: {
    getBank: function(bank) {
      this.form.bankName = bank.name;
      this.form.bankCode = bank.code;
      this.form.bankAccountName = bank.accountName;
      this.form.bankAccountNumber = bank.accountNumber;
      this.form.bankType = bank.accountType;
    },
    async cancel() {
      if (
        await this.$refs.confirm.open(
          "Confirmation",
          "Are you sure you want to cancel?"
        )
      ) {
        this.$router.push({ path: "/" });
      }
    },

    async getApprovedBanks() {
      this.$drs
        .get("/broker/drs/approved-banks")
        .then((response) => {
          // console.log(response.data.data.list);
          this.banks = response.data.data.list;

          this.loadingBtn = false;
        })
        .catch((e) => {
          console.log(e);
          this.loadingBtn = false;
        });
    },

    async onSubmit() {
      if (!this.$refs.form.validate()) {
        return false;
      }

      this.loadingBtn = true;
      let data = this.form;

      const { adminLogin } = this.userData;

      data.distributorDealerId = adminLogin.distributorId;
      data.distributorMobileNumber = adminLogin.distributorMobileNumber;

      await this.$drs
        .post("/broker/drs/distributor-top-up", data)
        .then((response) => {
          const res = response.data;
          this.$store.dispatch("addSnackbarMessage", res.message);
          this.$store.dispatch("addSnackbar", true);
          this.loadingBtn = false;

          if (res.status) {
            this.$refs.form.reset();
          }
        })
        .catch((e) => {
          console.log(e);
          this.loadingBtn = false;
        });
    },

    handleImage(value) {
      console.log(value);
      let fr = new FileReader();
      const self = this;
      fr.addEventListener("load", function(e) {
        //this is your base64

        //console.log(e.target.result);
        self.form.image = e.target.result.split(",")[1];
      });
      fr.readAsDataURL(value);
    },

    changeWallet() {
      // console.log(this.form.loadType)

      if (this.form.loadType === "Load Wallet") {
        this.vmoney.properties.hint = `Expected S2S Point: ${(
          Math.round((this.form.amount / 0.7) * 100) / 100
        ).toLocaleString(undefined, {
          minimumFractionDigits: 2,
        })}`;
      } else {
        this.vmoney.properties.hint = `Expected S2S Point: ${(
          Math.round((this.form.amount / 0.5) * 100) / 100
        ).toLocaleString(undefined, {
          minimumFractionDigits: 2,
        })}`;
      }
    },

    async getDistibutorType() {
      const { adminLogin } = this.userData;
      await this.$drs
        .get(
          `/broker/drs/distributor-type?distributorId=${adminLogin.distributorId}`
        )
        .then((response) => {
          // this.loadingData = false;
          const newArr = response.data;
          console.log(newArr.data.list[0].percent);
          // this.installBalance = newArr[0].installWallet;
          // this.loadBalance = newArr[0].loadWallet;
        })
        .catch((e) => {
          this.loadingData = false;
          console.log(e);
        });
    },
  },

  // mounted() {

  // },

  created() {
    this.getApprovedBanks();
    this.getDistibutorType();
  },

  computed: {
    userData() {
      return this.$store.getters.userData;
    },
  },
};
</script>
